// React-related imports
import * as React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Material-UI imports
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  FormControl,
  Link,
  Select,
  MenuItem,
  InputAdornment,
  TextField,
  TableFooter,
  Tooltip,
  Autocomplete,
  Table,
  Backdrop,
  CircularProgress,
} from '@mui/material';

// Icons imports
import {
  Close as CloseIcon,
  PictureAsPdf as PictureAsPdfIcon,
  InsertPhoto as InsertPhotoIcon,
  Cancel as CancelIcon,
  Upload as UploadIcon,
  AttachFile as AttachFileIcon,
  ErrorOutlineOutlined as ErrorOutlineOutlinedIcon,
} from '@mui/icons-material';

import UploadFileIcon from '@mui/icons-material/UploadFile';

// Third-party library imports
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import axios from 'axios';
import jwtDecode from 'jwt-decode';
import dayjs from 'dayjs';

// Project-specific imports
import { addCommas } from '../../utils/functions/commas';
import NotiAlert from '../NotiAlert/NotiAlert';
import NotiAlertComfirm from '../NotiAlert/NotiAlertComfirm';
import { useDiscountPrepaidMutation } from '../../services/paymentTransaction';
import { useGetGroupBankAllQuery } from '../../services/groupBank';
import { usePostSaveLogWhtMutation } from '../../services/saveLogWht';
import { useTranslation } from 'react-i18next';

function UploadSlip({
  openDialogSlip,
  setOpenDialogSlip,
  selectedRows,
  merchant,
  custNO,
  selectWHT,
  setSelectWHT,
  invoiceNOItems,
  federalTaxId,
  federal_hash_tax_id,
  customerName,
  refetchInvList,
  setSelectedRows,
}) {
  const feeRef = React.useRef(null);
  const paymentAmountRef = React.useRef(null);
  const bankRef = React.useRef(null);
  const calculationRequestRef = React.useRef(0);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [note, setNote] = useState('');
  const [dateValue, setDateValue] = useState(dayjs());
  const [selectWHTrate, setSelectWHTrate] = useState(3);
  const [importFile, setImportFile] = useState([]);
  const [importFileWHT, setImportFileWHT] = useState([]);
  const [paymentAmout, setPaymentAmout] = useState('');

  const [fee, setFee] = useState('');
  const [calculateValue, setCalculateValue] = useState('');

  const [discount, responseDiscount] = useDiscountPrepaidMutation();
  const [bankData, setBankData] = useState([]);

  const [selectBank, setSelectBank] = useState('');
  const [invoiceWHT, setInvoiceWHT] = useState([]);
  const [selcetInvoiceWHT, setSelectInvoiceWHT] = useState([]);

  const [hasError, setHasError] = useState(false);
  const [openAlertNoti, setOpenAlertNoti] = useState(false);
  const [openFailAlert, setOpenFailAlert] = useState(false);
  const [snackBarLoading, setSnackbarLoading] = useState(false);
  const [errorValue, setErrorValue] = useState('');
  const [openConfirm, setOpenConfirm] = useState(false);
  const token = localStorage.getItem('token');
  const roleAcc = jwtDecode(token).ROLE;
  const [valueTable, setValueTable] = useState('');
  const [valueAlert, setValueAlert] = useState('');
  const [hideWHTMenu, setHideWHTMenu] = useState(false);
  const [postSaveLogWht] = usePostSaveLogWhtMutation();

  const toNumberOrZero = (value) => {
    const parsed = Number(String(value ?? '').replace(/,/g, ''));
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const isWhtBlockedRow = (row = {}) => {
    const soNumber = String(row?.so_number || '').trim();
    const invoiceNo = String(row?.invoice_no || '').trim();
    const blockedSoPrefixes = ['SO02', 'SO12', 'SO13', 'SO09', 'SO07', 'SO05'];

    return (
      !soNumber ||
      blockedSoPrefixes.some((prefix) => soNumber.startsWith(prefix)) ||
      invoiceNo.startsWith('BOI')
    );
  };


  const formatBankOptionLabel = (option = {}) => option?.bank_fullname || '';

  const normalizeBankSearchText = (value = '') =>
    String(value).toLowerCase().replace(/[-\s]/g, '');

  const selectedBankOption =
    bankData.find((option) => option?.bank_code === selectBank) || null;

  const resetUploadForm = () => {
    // Invalidate any in-flight calculation so an older response cannot restore
    // values from the form that has just been closed or submitted.
    calculationRequestRef.current += 1;
    setNote('');
    setDateValue(dayjs());
    setImportFile([]);
    setImportFileWHT([]);
    setPaymentAmout('');
    setFee('');
    setCalculateValue('');
    setSelectBank('');
    setHasError(false);
    setSnackbarLoading(false);
    setOpenConfirm(false);
  };

  const renderPaymentType = (type) => {
    let color;
    let text;

    switch (type) {
      case 'Post-Paid':
        color = '#0288D1';
        text = t('app.postPaid');
        break;
      case 'prepaid':
        color = '#01579B';
        text = t('app.prePaid');
        break;
      default:
        color = 'inherit';
        text = type;
    }

    return <span style={{ color: color }}>{text}</span>;
  };

  useEffect(() => {
    setValueTable(selectedRows);
  }, [selectedRows]);

  const { data: bankAll } = useGetGroupBankAllQuery();

  useEffect(() => {
    setBankData(bankAll?.banks || []);
  }, [bankAll]);

  const handleSelectWhtRate = (event) => {
    setSelectWHTrate(event.target.value);
  };

  const sendUploadSlip = async () => {
    if (hideWHTMenu) {
      setSelectWHTrate(0); // กำหนดเป็น 0 ก่อนส่ง API ถ้าเมนูถูกซ่อน
    }

    setSnackbarLoading(true);
    setOpenConfirm(false);

    // ตรวจสอบยอดชำระเงิน
    const enteredPaymentAmount = Number(toNumberOrZero(paymentAmout).toFixed(2));
    const expectedGrandTotal = Number(
      toNumberOrZero(calculateValue.grandTotal).toFixed(2),
    );

    if (enteredPaymentAmount !== expectedGrandTotal) {
      setErrorValue(t('app.amountMismatch'));
      setOpenFailAlert(true);
      setSnackbarLoading(false);
      return; // หยุดทำงานของฟังก์ชันทันทีถ้ายอดไม่ตรงกัน
    }

    let apiUrl = '';

    if (
      roleAcc === 'ADMIN' || 
      roleAcc === 'SUPER ADMIN' || 
      roleAcc === 'SALE' || 
      roleAcc === 'SALES'
    ) {
      apiUrl = `${process.env.REACT_APP_API_URL_admin}/payment-transaction/upload/invoice?customerCode=${custNO}&sorgcode=${merchant}&federalTaxId=${federalTaxId}&customerName=${customerName}`;
    } else if (roleAcc === 'USER') {
      apiUrl = `${process.env.REACT_APP_API_URL}/payment-transaction/upload/invoice?customerCode=${custNO}&sorgcode=${merchant}&hashTaxId=${federal_hash_tax_id}&customerName=${customerName}`;
    }

    try {
      // Log Payload สำหรับ Redux API

      // FormData สำหรับ axios
      const formData = new FormData();
      const invoiceNos = selectedRows.map((row) => row.invoice_no);
      const selectedCustomerCodes = [
        ...new Set(selectedRows.map((row) => row.customer_code).filter(Boolean)),
      ];
      const totalAmount = calculateValue?.total_amount || 0;
const whtAmount = calculateValue?.whtAmount || '0';
const grandTotal = calculateValue?.grandTotal || 0;
const totalVat = calculateValue?.total_vat || 0;
const totalDiscount = calculateValue?.discount || 0;

      formData.append('invoiceNo', invoiceNos.join(','));
      formData.append('customerCodes', selectedCustomerCodes.join(','));
      formData.append('whtInvoiceNo', invoiceWHT.join(','));
      formData.append('transferAmount', toNumberOrZero(paymentAmout));
      formData.append('transferDate', dateValue);
      formData.append('transferBank', selectBank);
      formData.append('totalAmount', totalAmount);
      formData.append('totalWht', whtAmount);
      formData.append('totalVat', totalVat);
      formData.append('totalDiscount', totalDiscount);
      formData.append('totalPayAmount', grandTotal);
      formData.append('whtRate', selectWHTrate);
      formData.append('remark', note);
      formData.append('totalFee', toNumberOrZero(fee));

      importFileWHT.forEach((file) => {
        formData.append('whtEvidence', file);
      });

      importFile.forEach((file) => {
        formData.append('paymentEvidence', file);
      });

      // Log Payload สำหรับ API log
      const logPayload = {
        sorgcode: merchant,
        invoiceNo: selectedRows.map((row) => row.invoice_no),
        type: 'UPLOAD',
        whtInvoiceNo: selectWHT.map((row) => row.invoice_no),
      };

      const [response, logResponse] = await Promise.all([
        axios.post(apiUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }),
        postSaveLogWht(logPayload).unwrap(), // Redux API
      ]);

      // ตรวจสอบผลลัพธ์จาก API
      if (response.data.message === 'OK') {
        resetUploadForm();
        setOpenAlertNoti(true);
        setOpenDialogSlip(false);
        setSelectedRows([]);
      }
      if (refetchInvList) {
        refetchInvList(); // <-- reload invList จาก redux
      }

      // console.log('Upload successful', response);
      // console.log('Log saved', logResponse);
    } catch (error) {
      const messageError = error.response?.data?.error?.message;

      if (messageError === 'Error: PAYMENT EVIDENCE IS REQUIRED') {
        setErrorValue('กรุณาอัพโหลดหลักฐานการชำระเงิน');
      } else if (messageError === 'File too large') {
        setErrorValue('ไฟล์มีขนาดใหญ่เกินไป');
      } else if (
        messageError ===
        'Error: whtInvoiceNos found. WhtEvidenceFiles is required'
      ) {
        setErrorValue('กรุณาอัพโหลดหลักฐานหัก ภาษี ณ ที่จ่าย');
      } else if (messageError?.includes('action_by')) {
        setErrorValue('กรุณาระบุผู้ดำเนินการ (action_by)');
      } else {
        setErrorValue('เกิดข้อผิดพลาดบางอย่างจากเซิร์ฟเวอร์');
      }

      setOpenConfirm(false);
      setOpenFailAlert(true);
      setSnackbarLoading(false);

      console.error(
        'Error:',
        error.response ? error.response.data : error.message,
      );
    }
  };

  const onClickAlertUploadSlip = () => {
    // 1. ตรวจสอบข้อมูลพื้นฐาน (ค่าธรรมเนียม, ยอดเงิน, ธนาคาร)
    if (fee === '' || paymentAmout === '' || selectBank?.length === 0) {
      setHasError(true);
      if (fee === '') {
        feeRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (paymentAmout === '') {
        paymentAmountRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      } else if (selectBank?.length === 0) {
        bankRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
      // ---------------------------------------
    } else {
      setHasError(false);

      if (importFile.length === 0) {
        setErrorValue('กรุณาอัพโหลดหลักฐานการชำระเงิน');
        setOpenFailAlert(true);
        return;
      }

      if (invoiceWHT.length > 0 && importFileWHT.length === 0) {
        setErrorValue('กรุณาอัพโหลดหลักฐานหัก ภาษี ณ ที่จ่าย');
        setOpenFailAlert(true);
        return;
      }

    const itemsBOI = selectedRows.filter((i) => isWhtBlockedRow(i));

    const checkwhtBOI =
      selectedRows.length > 0
        ? itemsBOI?.length === selectedRows?.length
        : false;

    if (invoiceNOItems.length > 0 && checkwhtBOI === false) {
      setOpenConfirm(true);
    } else {
      sendUploadSlip();
    }
    }
  };

  const handleCloseDialogUpload = () => {
    setOpenAlertNoti(false);
    setOpenFailAlert(false);
    // setOpenDialogSlip(false);
  };

  const formatFileSize = (size) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  };

  const handleDiscount = async () => {
    const requestId = calculationRequestRef.current + 1;
    calculationRequestRef.current = requestId;
    const payload = {
      body: {
        wht_check: selectWHT,
        row: selectedRows,
        wht_rate: selectWHTrate,
        fee,
        is_upload: true,
      },
    };

    const res = await discount(payload);
    if (calculationRequestRef.current === requestId) {
      setCalculateValue(res?.data?.data);
    }
  };

  // useEffect(() => {
  //   handleDiscount();
  // }, [selectWHT, selectWHTrate, fee]);

  useEffect(() => {
    if (openDialogSlip) {
      handleDiscount();
    }
  }, [openDialogSlip, selectWHTrate, fee, selectWHT]);

  useEffect(() => {
    // fetchGroupBank();
    const invoiceWHTvalue = selectWHT.map((row) => row.invoice_no);
    setInvoiceWHT(invoiceWHTvalue);
  }, [selectWHT]);

  const isSelected = (row) =>
    selectWHT.some((selectedRow) => selectedRow.invoice_no === row.invoice_no);

  const handleSelectWHT = (row) => {
    if (isSelected(row)) {
      setSelectWHT(
        selectWHT.filter(
          (selectedRow) => selectedRow.invoice_no !== row.invoice_no,
        ),
      );
      setInvoiceWHT(
        invoiceWHT.filter((invoiceNo) => invoiceNo !== row.invoice_no),
      );
    } else {
      setSelectWHT([
        ...selectWHT,
        {
          invoice_no: row.invoice_no,
          period: row.period,
          so_number: row.so_number,
        },
      ]);
      setInvoiceWHT([...invoiceWHT, row.invoice_no]);
    }
  };

  const handleChangePaymentAmount = (event) => {
    setPaymentAmout(event.target.value);
  };
  const handleChangeFee = (event) => {
    setFee(event.target.value);
  };

  const handleDeleteWHT = (fileWHTDelete) => () => {
    setImportFileWHT((fileWHT) =>
      fileWHT.filter((fileWHT) => fileWHT.name !== fileWHTDelete.name),
    );
  };

  const handleDelete = (fileDelete) => () => {
    setImportFile((file) =>
      file.filter((file) => file.name !== fileDelete.name),
    );
  };

  // ------------------ [แก้ไข] เพิ่มการกรองไฟล์ในฟังก์ชันนี้ ------------------
  const handleFileUpload = (event) => {
    const { files } = event.target;
    const folderFiles = Array.from(files);

    // กรองเฉพาะไฟล์ที่เป็น PDF หรือ รูปภาพ
    const validFiles = folderFiles.filter(
      (file) =>
        file.type === 'application/pdf' || file.type.startsWith('image/'),
    );

    // ถ้ามีไฟล์ที่ไม่ผ่านเงื่อนไข ให้แจ้งเตือน (Optional)
    if (validFiles.length < folderFiles.length) {
      setErrorValue('รองรับเฉพาะไฟล์รูปภาพและ PDF เท่านั้น');
      setOpenFailAlert(true);
    }

    setImportFile((prevFiles) => [...prevFiles, ...validFiles]);
    event.target.value = null; // Reset input เพื่อให้เลือกไฟล์เดิมซ้ำได้ถ้าต้องการ
  };

  // ------------------ [แก้ไข] เพิ่มการกรองไฟล์ในฟังก์ชันนี้ ------------------
  const handleFileUploadWHT = (event) => {
    const { files } = event.target;
    const folderFiles = Array.from(files);

    // กรองเฉพาะไฟล์ที่เป็น PDF หรือ รูปภาพ
    const validFiles = folderFiles.filter(
      (file) =>
        file.type === 'application/pdf' || file.type.startsWith('image/'),
    );

    if (validFiles.length < folderFiles.length) {
      setErrorValue('รองรับเฉพาะไฟล์รูปภาพและ PDF เท่านั้น');
      setOpenFailAlert(true);
    }

    setImportFileWHT((prevFiles) => [...prevFiles, ...validFiles]);
    event.target.value = null; // Reset input
  };

  const handleChangeNote = (e) => {
    setNote(e.target.value);
  };

  const handleClose = () => {
    resetUploadForm();
    setOpenDialogSlip(false);
  };

  useEffect(() => {
    // ตรวจสอบว่ามี checkbox ใดถูกเลือกหรือไม่
    const isAnyRowSelected = selectWHT.length > 0;

    // ตรวจสอบว่า checkbox ทั้งหมดถูกปิดการใช้งานหรือไม่
    const areAllRowsDisabled =
      selectWHT.length === 0 || selectWHT.every((row) => isWhtBlockedRow(row));

    // กรณีที่ checkbox ไม่มีการเลือกและทุก checkbox ถูกปิดการใช้งาน
    if (!isAnyRowSelected || areAllRowsDisabled) {
      setHideWHTMenu(true);
      setSelectWHTrate(0);
    } else {
      setHideWHTMenu(false);
      setSelectWHTrate(3);
    }
  }, [selectWHT]);

  const customCellHeader = {
    whiteSpace: 'nowrap',
    backgroundColor: 'primary.main',
    color: 'white',
    padding: '14px',
  };

  const customCellData = {
    fontSize: '12px',
    padding: '2px',
  };
  const customCellInvAndSo = {
    fontSize: '12px',
    padding: '2px',
    fontFamily: 'monospace',
  };

  const parseDate = (str) => {
    if (!str) return 0;
    // "20251001" -> "2025-10-01"
    const year = str.slice(0, 4);
    const month = str.slice(4, 6);
    const day = str.slice(6, 8);
    const parsed = new Date(`${year}-${month}-${day}`);
    return Number.isNaN(parsed.getTime()) ? 0 : parsed.getTime();
  };

  const formatPeriodDate = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '-';
    const normalized = /^\d{8}$/.test(raw)
      ? `${raw.slice(0, 4)}-${raw.slice(4, 6)}-${raw.slice(6, 8)}`
      : raw;
    const parsed = dayjs(normalized);
    return parsed.isValid() ? parsed.format('DD MMM YYYY') : '-';
  };

  return (
    <>
      <Dialog
        open={openDialogSlip}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleClose(event, reason);
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          '& .MuiDialog-paper': {
            width: '100%',
            maxWidth: '100%',
            height: '100%',
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <div className="flex justify-between">
            <div className="hidden lg:block text-green-600 ml-5 font-bold ">
              {t('app.uploadSlip')}
            </div>
            <div className="lg:hidden text-green-600 ml-5 font-bold ">
              {t('app.uploadSlip')}
            </div>

            <div>
              <button>
                <CloseIcon onClick={handleClose} />
              </button>
            </div>
          </div>
        </DialogTitle>

        <DialogContent>
          <div className="flex flex-col lg:flex-row justify-between lg:h-full">
            <div className="w-full  border-dashed border-gray-300 border-2 p-2 md:border-0 md:flex-[2] md:pr-4 overflow-y-auto">
              <div className="md:border-2 ">
                <TableContainer sx={{ maxHeight: 380 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.invoiceNo')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.period')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.saleOrder')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.serviceName')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.startDate')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.endDate')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.paymentType')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.totalAmount')}
                        </TableCell>

                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.wht')}
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    {_.size(selectedRows) ? (
                      <TableBody>
                        {selectedRows
                          .slice()
                          .sort(
                            (a, b) =>
                              parseDate(a.period_start_date) -
                              parseDate(b.period_start_date),
                          )
                          .map((row, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                '&:last-child td, &:last-child th': {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center" sx={customCellInvAndSo}>
                                {row.invoice_no}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {row.period}
                              </TableCell>
                              <TableCell align="center" sx={customCellInvAndSo}>
                                {row.so_number}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {row.service_name}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {formatPeriodDate(row.period_start_date)}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {formatPeriodDate(row.period_end_date)}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {renderPaymentType(row.payment_type)}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {addCommas(row.invoice_amount_exclude_vat)}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                <Tooltip
                                  title={
                                    isWhtBlockedRow(row)
                                      ? 'เนื่องจากรายการนี้ไม่สามารถหัก WHT ได้'
                                      : ''
                                  }
                                >
                                  <span>
                                    <Checkbox
                                      sx={{
                                        '&.Mui-disabled': {
                                          color: '#DCDCDC',
                                        },
                                      }}
                                      onChange={() => handleSelectWHT(row)}
                                      checked={
                                        isWhtBlockedRow(row) ? false : isSelected(row)
                                      }
                                      disabled={isWhtBlockedRow(row)}
                                    />
                                  </span>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    ) : (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={10} align="center">
                            <div>ไม่มีข้อมูล</div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}

                    <TableFooter className="bg-gray-200 sticky bottom-0 border-t-2 border-gray-600 ">
                      <TableRow>
                        <TableCell colSpan={6} />
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                          {t('app.totalAmount')}
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>
  {addCommas(calculateValue?.total_amount || 0)}
</TableCell>
                        <TableCell />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </TableContainer>
              </div>
              <div className="mt-4 flex flex-col">
                <div className="mt-2">
                  <ErrorOutlineOutlinedIcon sx={{ color: 'red' }} />
                  <span className="ml-2 text-xs xl:text-sm">
                    {t('app.boiExemptInfo')}
                    <Link
                      href="BOICloud.pdf"
                      underline="hover"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('app.downloadFile')}
                    </Link>
                  </span>
                </div>

                <div className="xl:mt-5">
                  <ErrorOutlineOutlinedIcon sx={{ color: 'red' }} />
                  <span className="ml-2 text-xs xl:text-sm">
                    {t('app.offlinePaymentSteps')}
                  </span>
                </div>
                <div className="text-xs xl:text-sm xl:ml-8">
                  {t('app.offlineStep1')}
                </div>

                <div className="text-xs xl:text-sm xl:ml-8">
                  {t('app.offlineStep2')}
                  <UploadFileIcon sx={{ color: '#818181' }} />
                </div>
              </div>
              <div className=" mt-5  border-2 border-gray-900 w-[100%]  rounded-md border-dashed bg-gray-100">
                <div className="ml-2 mt-2">
                  <div> {t('app.remark')} </div>
                  <textarea
                    className="w-full h-[60px] border-none focus:outline-none bg-gray-100 resize-none"
                    onChange={handleChangeNote}
                    value={note}
                    label
                  />
                </div>
              </div>
            </div>

            {/* กล่องขวา */}
            <Backdrop
              open={snackBarLoading}
              sx={{
                color: '#fff',
                zIndex: 999999999, // สูงพอ
              }}
            >
              <CircularProgress color="inherit" />
              <span style={{ marginLeft: '1rem', fontSize: '1.2rem' }}>
                {t('app.uploading')}
              </span>
            </Backdrop>

            <div className="w-full lg:flex-[1] mt-5 border-dashed border-gray-300 border-2  lg:mt-0 lg:border-l lg:border-gray-200  overflow-y-auto">
              <div className="flex-1 p-4 space-y-6">
                <div>
                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-200 divide-y divide-gray-200">
                    <div className="flex justify-between py-2 font-bold">
                      <span>{t('app.pay')}</span>
                      <span>
                        {selectedRows.length} {t('app.xPeriods')}
                      </span>
                    </div>
                    <div className="flex justify-between items-center pt-2 font-bold">
                      <span>{t('app.payTo')}</span>
                      <span className="text-right text-sm">
                        {selectedRows[0]?.customer?.sorgname}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <div className="flex justify-between font-bold">
                    <span>{t('app.totalAmount')}</span>
                    <span>{addCommas(calculateValue.total_amount)}</span>
                  </div>
                  <div className="flex justify-between font-bold">
                    <span>{t('app.vat')}(7%)</span>
                    <span>{addCommas(calculateValue.total_vat)}</span>
                  </div>
                </div>

                {!hideWHTMenu && (
                  <div className="space-y-4 pt-6 border-t border-gray-200">
                    <h3 className="text-lg font-semibold text-gray-800">
                      {t('app.wht')}
                    </h3>

                    {/* WHT Rate Selector */}
                    <div className="flex justify-between items-center">
                      <span className="ml-1 font-bold">{t('app.wht')}(%)</span>
                      <FormControl sx={{ minWidth: 120 }}>
                        <Select
                          value={selectWHTrate}
                          onChange={handleSelectWhtRate}
                          size="small"
                          endAdornment={
                            <InputAdornment
                              position="end"
                              sx={{ marginRight: '20px', color: '#d6d6d6' }}
                            >
                              %
                            </InputAdornment>
                          }
                          inputProps={{
                            style: { padding: '1px', height: '30px' },
                          }}
                        >
                          <MenuItem value={1} key={1}>
                            1
                          </MenuItem>
                          <MenuItem value={3} key={3}>
                            3
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>

                    {/* WHT Info Box (ใช้กล่องสีอ่อน) */}
                    <div className="p-3 text-xs bg-gray-50 rounded-lg border border-gray-200 space-y-2">
                      <div className="text-gray-600">
                        {t('app.boiExemptInfo')}
                        <Link
                          href="BOICloud.pdf"
                          underline="hover"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t('app.downloadFile')}
                        </Link>
                      </div>
                      <div className="text-yellow-700">
                        {t('app.whtContact')}
                      </div>
                    </div>

                    {/* WHT Upload Section */}
                    <div>
                      <div className="flex justify-between items-center mb-2">
                        <div>
                          <div className="text-sm ml-1 font-bold">
                            {t('app.attachWhtDoc')}
                          </div>
                          <div className="text-yellow-600 font-medium text-xs ml-1">
                            {t('app.fileSizeLimit')}
                          </div>
                        </div>
                        <label htmlFor="fileWHT">
                          <Button
                            variant="contained"
                            sx={{ color: 'white' }}
                            component="span"
                            size="small"
                            disabled={snackBarLoading}
                          >
                            <UploadIcon />
                            {t('app.selectFile')}
                          </Button>
                        </label>
                        <input
                          type="file"
                          style={{ display: 'none' }}
                          id="fileWHT"
                          onChange={handleFileUploadWHT}
                          multiple
                          accept="image/*,application/pdf"
                          disabled={snackBarLoading}
                        />
                      </div>
                      {/* WHT File List Box (ใช้เส้นขอบสีอ่อน) */}
                      <div
                        className={`border border-gray-300 rounded-lg mt-3 bg-white shadow-sm ${importFile.length === 0 && hasError ? 'border-red-500' : ''}`}
                      >
                        <div className="p-3 space-y-2">
                          {importFileWHT?.length === 0 ? (
                            <div className="text-gray-400 text-sm text-center">
                              {t('app.noFileUploaded')}
                            </div>
                          ) : (
                            importFileWHT.map((file, index) => {
                              let icon;
                              if (file.type === 'application/pdf') {
                                icon = (
                                  <PictureAsPdfIcon sx={{ color: '#E53935' }} />
                                );
                              } else if (file.type.startsWith('image/')) {
                                icon = (
                                  <InsertPhotoIcon sx={{ color: '#1E88E5' }} />
                                );
                              } else {
                                icon = (
                                  <AttachFileIcon sx={{ color: '#6D6D6D' }} />
                                );
                              }
                              return (
                                <div
                                  key={index}
                                  className="flex items-center bg-gray-50 hover:bg-gray-100 rounded-md px-3 py-2 transition"
                                >
                                  <div className="text-xl">{icon}</div>
                                  <div className="ml-3 flex flex-col text-sm overflow-hidden">
                                    <span className="font-medium text-gray-800 truncate max-w-[200px]">
                                      {file.name}
                                    </span>
                                    <span className="text-gray-500 text-xs">
                                      ({formatFileSize(file.size)})
                                    </span>
                                  </div>
                                  <button
                                    className="ml-auto text-red-500 hover:text-red-700"
                                    onClick={handleDeleteWHT(file)}
                                  >
                                    <CancelIcon />
                                  </button>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="space-y-4 pt-6 border-t border-gray-200">
                  {/* Final Totals */}
                  <div className="space-y-2">
                    {!hideWHTMenu && (
                      <div className="flex justify-between text-green-600 font-medium">
                        <span>{t('app.whtAmount')}</span>
                        <span>{addCommas(calculateValue.whtAmount)}</span>
                      </div>
                    )}
                    <div className="flex justify-between font-bold text-xl text-gray-900">
                      <span>{t('app.grandTotalThb')}</span>
                      <span>{addCommas(calculateValue?.grandTotal)}</span>
                    </div>
                  </div>

                  {/* Form Inputs (คง layout responsive เดิมไว้) */}
                  <div className="space-y-3 pt-4">
                    <div className="flex flex-col sm:flex-row justify-between sm:items-center">
                      <div className="w-full sm:w-1/3 mb-1 sm:mb-0 font-medium">
                        {t('app.fee')}
                      </div>
                      <div className="w-full sm:w-2/3">
                        <TextField
                          inputRef={feeRef}
                          placeholder={t('app.fee')}
                          sx={{ width: '100%' }}
                          size="small"
                          onChange={handleChangeFee}
                          value={fee}
                          id="outlined-basic"
                          variant="outlined"
                          type="number"
                          error={hasError && fee.trim() === ''}
                          helperText={
                            hasError && fee.trim() === ''
                              ? t('app.enterFee')
                              : ''
                          }
                        />
                      </div>
                    </div>
                    <div className="flex flex-col sm:flex-row justify-between sm:items-center">
                      <div className="w-full sm:w-1/3 mb-1 sm:mb-0 font-medium">
                        {t('app.paymentAmount')}
                      </div>
                      <div className="w-full sm:w-2/3">
                        <TextField
                          inputRef={paymentAmountRef}
                          placeholder={t('app.paymentAmount')}
                          sx={{ width: '100%' }}
                          size="small"
                          onChange={handleChangePaymentAmount}
                          value={paymentAmout}
                          variant="outlined"
                          type="number"
                          error={hasError && paymentAmout.trim() === ''}
                          helperText={
                            hasError && paymentAmout.trim() === ''
                              ? t('app.enterPaymentAmount')
                              : ''
                          }
                        />
                      </div>
                    </div>
                    <div className="flex flex-col sm:flex-row justify-between sm:items-center">
                      <div className="w-full sm:w-1/3 mb-1 sm:mb-0 font-medium">
                        {t('app.paymentBank')}
                      </div>
                      <div className="w-full sm:w-2/3">
                        <Autocomplete
                          size="small"
                          options={bankData}
                          value={selectedBankOption}
                          isOptionEqualToValue={(option, value) =>
                            option?.bank_code === value?.bank_code
                          }
                          getOptionLabel={formatBankOptionLabel}
                          filterOptions={(options, { inputValue }) => {
                            const searchText = normalizeBankSearchText(inputValue);
                            if (!searchText) return options;

                            return options.filter((option) =>
                              normalizeBankSearchText(
                                `${option?.bank_fullname || ''}`,
                              ).includes(searchText),
                            );
                          }}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              setSelectBank(newValue.bank_code);
                            } else {
                              setSelectBank('');
                            }
                          }}
                          renderOption={(props, option) => (
                            <li {...props} key={option?.bank_code}>
                              {option?.bank_fullname}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              inputRef={bankRef}
                              {...params}
                              placeholder={t('app.paymentBank')}
                              error={hasError && selectBank.length === 0}
                              helperText={
                                hasError && selectBank.length === 0
                                  ? t('app.paymentBank')
                                  : ''
                              }
                              size="small"
                              sx={{ width: '100%' }}
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div className="flex flex-col sm:flex-row justify-between sm:items-center">
                      <div className="w-full sm:w-1/3 mb-1 sm:mb-0 font-medium">
                        {t('app.paymentDate')}
                      </div>
                      <div className="w-full sm:w-2/3">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            format="DD/MM/YYYY"
                            sx={{
                              height: '35px',
                              width: '100%',
                              backgroundColor: '#fff',
                            }}
                            slotProps={{ textField: { size: 'small' } }}
                            value={dateValue}
                            views={['year', 'month', 'day']}
                            onChange={(newValue) => {
                              setDateValue(newValue);
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="space-y-4 pt-6 border-t border-gray-200">
                  <div className="flex justify-between items-center mb-2">
                    <div>
                      <div className="text-sm ml-1 font-bold">
                        {t('app.attachProof')}
                      </div>
                      <div className="text-yellow-600 font-medium text-xs ml-1">
                        {t('app.fileSizeLimit')}
                      </div>
                    </div>
                    <label htmlFor="file">
                      <Button
                        variant="contained"
                        sx={{ color: 'white' }}
                        component="span"
                        size="small"
                        disabled={snackBarLoading}
                      >
                        <UploadIcon />
                        {t('app.selectFile')}
                      </Button>
                    </label>
                    <input
                      type="file"
                      style={{ display: 'none' }}
                      id="file"
                      onChange={handleFileUpload}
                      multiple
                      accept="image/*,application/pdf"
                      disabled={snackBarLoading}
                    />
                  </div>
                  {/* Payment File List Box */}
                  <div
                    className={`border border-gray-300 rounded-lg mt-3 bg-white shadow-sm ${importFile.length === 0 && hasError ? 'border-red-500' : ''}`}
                  >
                    <div className="p-3 space-y-2">
                      {importFile?.length === 0 ? (
                        <div className="text-gray-400 text-sm text-center">
                          {t('app.noFileUploaded')}
                        </div>
                      ) : (
                        importFile.map((file, index) => {
                          let icon;
                          if (file.type === 'application/pdf') {
                            icon = (
                              <PictureAsPdfIcon sx={{ color: '#E53935' }} />
                            );
                          } else if (file.type.startsWith('image/')) {
                            icon = (
                              <InsertPhotoIcon sx={{ color: '#1E88E5' }} />
                            );
                          } else {
                            icon = <AttachFileIcon sx={{ color: '#6D6D6D' }} />;
                          }
                          return (
                            <div
                              key={index}
                              className="flex items-center bg-gray-50 hover:bg-gray-100 rounded-md px-3 py-2 transition"
                            >
                              <div className="text-xl">{icon}</div>
                              <div className="ml-3 flex flex-col text-sm">
                                <span className="font-medium text-gray-800">
                                  {file.name}
                                </span>
                                <span className="text-gray-500 text-xs">
                                  ({formatFileSize(file.size)})
                                </span>
                              </div>
                              <button
                                className="ml-auto text-red-500 hover:text-red-700"
                                onClick={handleDelete(file)}
                              >
                                <CancelIcon />
                              </button>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
              </div>{' '}
              <div className="sticky bottom-0 bg-white p-4 border-t border-gray-200">
                <div className="flex flex-col gap-2">
                  <Button
                    onClick={onClickAlertUploadSlip}
                    variant="contained"
                    sx={{ color: 'white' }}
                    fullWidth
                    disabled={snackBarLoading}
                  >
                    {t('app.uploadSlip')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <NotiAlert
        open={openAlertNoti}
        setOpen={setOpenAlertNoti}
        title={t('app.uploadSuccess')}
        value="success"
        onButtonClick={handleCloseDialogUpload}
      />
      <NotiAlert
        setValueAlert={setValueAlert}
        valueAlert={valueAlert}
        setErrorValue={setErrorValue}
        errorValue={errorValue}
        open={openFailAlert}
        setOpen={setOpenFailAlert}
        // title="กรุณาอัปโหลดหนังสือรับรองการหักภาษี ณ ที่จ่าย"
        value="cancel"
        onButtonClick={handleCloseDialogUpload}
      />
      <NotiAlertComfirm
        open={openConfirm}
        setOpen={setOpenConfirm}
        invoiceNOItems={invoiceNOItems}
        onButtonClick={sendUploadSlip}
      />
    </>
  );
}

export default UploadSlip;
